<template>
  <!-- 评价订单 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 商品订单
        <span>> 订单详情</span>
      </div>
      <personalSidebar>
        <div class="right-content">
          <div class="r-title">评价订单</div>
          <div class="detail-box">
            <div class="bottom-box">
              <div class="left-text">
                订单编号：{{orderDetail.order_sn}}
                <span>下单时间：{{orderDetail.create_time}}</span>
              </div>
              <div class="price-box">
                实付款：
                <span>¥</span>
                <span class="price">{{orderDetail.order_amount}}</span>
                <template v-if="orderDetail.pay_type === 2">
                  <i class="iconfont-icon icon-weixinfukuan"></i>
                  <span class="pay-text">微信支付</span>
                </template>
                <template v-if="orderDetail.pay_type === 1">
                  <i class="iconfont-icon icon-zhifubao"></i>
                  <span class="pay-text">支付宝支付</span>
                </template>
                <template v-if="orderDetail.pay_type === 3">
                  <i class="iconfont-icon icon-duigongzhuanzhang"></i>
                  <span class="pay-text">对公打款</span>
                </template>
                <template v-if="orderDetail.pay_type === 4">
                  <i class="iconfont-icon icon-xianjinzhifu"></i>
                  <span class="pay-text">现金支付</span>
                </template>
              </div>
            </div>
            <div class="order-module" v-for="(item,index) in orderList" :key="index">
              <div class="top-box">
                <div
                  class="img"
                  :style="{ backgroundImage: 'url( ' + imgUrl + item['thumb']+ ')' }"
                ></div>
                <div class="right-detail">
                  <div class="d-title">{{item.goods_name}}</div>
                  <div class="type-box">
                    <span>规格：</span>全集
                    <span class="num">数量：</span>
                    <i class="iconfont el-icon-close"></i>
                    {{item.goods_number}}
                  </div>
                </div>
              </div>
              <div class="score-box">
                <div>商品评分</div>
                <el-rate
                  v-model="item.scoreNum"
                  text-color="#FF9C00"
                  show-score
                  score-template="{value}.0"
                  :colors="scoreColor"
                ></el-rate>
              </div>
              <div class="evaluate-content">
                <div>评价晒单</div>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="item.evaluateWords"
                ></el-input>
              </div>
              <div class="img-box">
                <el-upload
                  class="img-list"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :on-remove="handleRemove"
                  :on-success="successUpload"
                  :file-list="item.fileList"
                >
                  <i class="el-icon-plus" @click="getFileIndex(index)"></i>
                </el-upload>
                <div class="input-emo-box" @mouseover="selectStyle(index)">
                  <i class="iconfont-icon icon-biaoqing"></i>
                  表情
                  <div class="emo-box">
                    <VEmojiPicker @select="selectEmoji"></VEmojiPicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="evaluate-button" @click="evaluateCourse">立即评价</div>
          </div>
          <!-- <div class="shop-select">
            评价商品
            <el-select @change="shopChange" class="c-list" v-model="shopUuid" placeholder="选择评价商品">
              <el-option
                v-for="item in orderDetail.goods"
                :key="item.goods_uuid"
                :label="item.goods_name"
                :value="item.goods_uuid"
              ></el-option>
            </el-select>
          </div>-->
        </div>
      </personalSidebar>
    </div>
  </div>
</template>
<script>
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';
import { upload_url } from '../api/index';
export default {
  name: 'evaluateOrder',
  components: {
    personalSidebar
  },
  data() {
    return {
      imgUrl: imgUrl,
      scoreNum: null,
      evaluateWords: '',
      uploadUrl: upload_url,
      scoreColor: ['#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00'],
      course_uuid: '',
      orderDetail: {},
      order_sn: '',
      fileList: [],
      shopUuid: '',
      orderList: [],
      fileIndex: ''
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value) {
      this.order_sn = value.order_sn;
      this.getDetail(value.order_sn);
    }
  },
  methods: {
    selectStyle(index) {
      console.log(index);
      this.fileIndex = index;
    },
    getFileIndex(index) {
      console.log(index);
      this.fileIndex = index;
    },
    shopChange(val) {
      this.shopUuid = val;
    },
    // 上传成功
    successUpload(res, file, fileList) {
      console.log(res, file, fileList);
      let fileArr = fileList;
      if (res.result) {
        let list = [];
        fileArr.map(ele => {
          console.log(ele.response.result);
          list.push(ele.response.result);
        });
        console.log(list);
        this.$message.success('上传成功！');
        this.orderList[this.fileIndex].fileList = list;
      } else {
        this.$message.warning('上传失败！');
      }
    },
    evaluateCourse() {
      console.log(this.orderList);
      let arr = [];
      this.orderList.forEach(ele => {
        const params = {
          order_sn: this.order_sn,
          detail: ele.evaluateWords,
          evaluate: ele.scoreNum ? ele.scoreNum : 5,
          imgs: ele.fileList ? ele.fileList : [],
          goods_uuid: ele.goods_uuid
        };
        arr.push(params);
      });
      console.log(arr);
      api.evaluateGood(arr).then(res => {
        if (res.result) {
          this.$message.success('提交成功！');
          //   this.evaluateWords = '';
          //   this.scoreNum = 0;
          //   this.fileList = [];
          //   this.shopUuid = '';
          this.$router.go(-1);
        } else {
          this.$message.success(res.message);
        }
      });
    },
    //  获取详情
    getDetail(order_sn) {
      api.getOrderDetail({ order_sn: order_sn }).then(res => {
        if (res.result) {
          this.orderDetail = res.result;
          this.orderList = res.result.goods;
          this.orderList.map(ele => {
            // ele.scoreNum = 0;
            // ele.evaluateWords = '';
            // ele.fileList = [];
          });
          console.log(this.orderList);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    selectEmoji(emoji) {
      console.log(emoji);
      this.orderList[this.fileIndex].evaluateWords += emoji.data;
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.course-container {
  //   width: 72%;
  padding: 50PX 0;
  margin: 0 auto;
}
.nav-box {
  width: 72%;
  margin: 0 auto;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.right-content {
  width: 72%;
  padding: 32PX 46PX;
  background-color: #ffffff;
  .r-title {
    padding-bottom: 20PX;
    margin-bottom: 45PX;
    font-size: 20PX;
    font-weight: bold;
    border-bottom: 1PX solid #ececec;
  }
}
.detail-box {
  position: relative;
  padding: 22PX 40PX 30PX;
  background-color: #f6f6f6;
  .top-box {
    display: flex;
    align-items: center;
    padding-bottom: 20PX;
    margin-bottom: 20PX;
  }
  .order-module {
    margin-bottom: 30PX;
  }
  .img {
    width: 96PX;
    height: 96PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-detail {
    flex: 1;
    padding-left: 20PX;
  }
  .d-title {
    width: 68%;
    margin-bottom: 14PX;
    font-size: 18PX;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .type-box {
    span {
      color: #999999;
    }
    .num {
      padding-left: 16PX;
    }
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 14PX;
    margin-bottom: 20PX;
    border-bottom: 1PX solid #ebebeb;
  }
  .left-text {
    color: #777777;
    span {
      padding-left: 20PX;
    }
  }
  .price-box {
    color: #999999;
    span {
      color: #dd0707;
      font-weight: bold;
    }
    .price {
      font-size: 22PX;
    }
    .iconfont-icon {
      padding-left: 22PX;
      color: #6bcc03;
    }
    .pay-text {
      color: #333333;
      font-weight: normal;
    }
  }
}
.score-box,
.evaluate-content {
  display: flex;
  margin-bottom: 28PX;
  > div {
    padding-right: 22PX;
    font-size: 18PX;
    color: #8c8c8c;
  }
}
.shop-select {
  display: flex;
  align-items: center;
  margin-bottom: 28PX;
  font-size: 18PX;
  color: #8c8c8c;
  .c-list {
    flex: 1;
    margin-left: 20PX;
  }
}
.img-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 30PX 0 100PX;
  margin-bottom: 76PX;
  .img-list {
    width: 80%;
    .el-icon-plus {
      width: 88PX;
      line-height: 88PX;
    }
  }
}
/deep/ {
  .el-rate__icon {
    font-size: 20PX;
  }
  .el-textarea {
    flex: 1;
  }
  .el-textarea__inner {
    background: #fafafa;
    border-radius: 14PX;
    border: 1PX solid #d7d6d6;
  }
  .el-upload--picture-card {
    width: 88PX;
    height: 88PX;
    line-height: 88PX;
    border-radius: 4PX;
    border-color: #979797;
  }
}
.evaluate-button {
  width: 196PX;
  margin: 0 auto 30PX;
  font-size: 18PX;
  color: #ffffff;
  text-align: center;
  line-height: 50PX;
  letter-spacing: 2PX;
  background-color: #f1a373;
  border-radius: 45PX;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.input-emo-box {
  position: relative;
  color: 18PX;
  cursor: pointer;
  &:hover {
    .emo-box {
      display: block;
    }
  }
  .iconfont-icon {
    position: relative;
    top: 4PX;
    padding-right: 4PX;
    font-size: 26PX;
    color: #ff9c00;
  }
  .emo-box {
    position: absolute;
    display: none;
    top: 30PX;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/evaluateOrder.vue